import { render, staticRenderFns } from "./productBarCode.vue?vue&type=template&id=6cb7a230&scoped=true&"
import script from "./productBarCode.vue?vue&type=script&lang=js&"
export * from "./productBarCode.vue?vue&type=script&lang=js&"
import style0 from "./productBarCode.vue?vue&type=style&index=0&id=6cb7a230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7a230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VIcon,VRow,VTextField})
